import { useState, useEffect } from "react";
import { useSelector, useDispatch } from "react-redux";
import { removeField } from "../../stores/customForm/customFormActions";

const CustomFormField = ({ field_id, page_number, position }) => {
  const dispatch = useDispatch();
  const memberTypeProperties = useSelector(
    (state) => state.customForm.member_type_properties
  );
  const [fieldHtml, setFieldHtml] = useState(
    <i className="fa fa-spinner fa-spin"></i>
  );

  useEffect(() => {
    const field = memberTypeProperties.find((item) => item.id === field_id);
    if (field && field.html) {
      setFieldHtml(<div dangerouslySetInnerHTML={{ __html: field.html }}></div>);
    }
  }, [field_id, memberTypeProperties]);

  const handleRemoveClick = (e) => {
    e.preventDefault();
    dispatch(removeField(page_number, field_id));
  };

  return (
    <li
      data-member-type-property-id={field_id}
      data-position={position}
    >
      {fieldHtml}
      <a className="remove_link" onClick={handleRemoveClick} href="##">
        Remove
      </a>
    </li>
  );
};

export default CustomFormField;
